// @flow
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';

import theme from '../../../../../theme-config';
import Icon from '../../../../../components/common/Icon';
import I18n from '../../../../../lib/i18n';

class SimCardInformation extends PureComponent<{}> {
  styles = getStyles();

  render() {
    const styles = this.styles;

    return (
      <>
        <View style={styles.textContainer}>
          <Icon name="simcard" style={styles.icon} />
          <Text style={styles.text}>{I18n.t('SignUp.ConfirmPlan.simCardInformation')}</Text>
        </View>
        <View style={styles.separator} />
      </>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    textContainer: {
      alignItems: 'center',
      flexDirection: 'row',
      paddingHorizontal: 20,
      paddingVertical: 15,
    },
    icon: {
      color: theme.secondaryColor,
      fontSize: 16,
      marginRight: 20,
    },
    text: {
      color: theme.secondaryColor,
      fontSize: 16,
      fontWeight: '400',
      flex: 1,
    },
    separator: {
      backgroundColor: theme.gray.normal,
      opacity: 0.25,
      height: 2,
      marginBottom: 15,
    },
  });

export default SimCardInformation;
